<ca-clickable-link
  [innerHtml]="
    'Analysis::GenAI.Project.FailedNotificationMessage' | abpLocalization : payloadData?.name
  "
  (linkClicked)="onClick()">
</ca-clickable-link>
